"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _zIndex = _interopRequireDefault(require("./settings/z-index"));

// this is temporary for now just go with it
// this can get removed into it's own spot later
// the reason for luna.luna is that the first key is dropped when passed to theme={luna}
// we want to name space these styles so they don't push out our default ones
function findValue(n, arr) {
  // i hate you IE just die already
  // instead of polyfill i switched to for
  for (var i = 0; i < arr.length; i++) {
    try {
      if (arr[i][n]) {
        return arr[i][n];
      }
    } catch (err) {
      console.error(err);
    }
  }
}

var colors = {
  ultramarine: function ultramarine(n) {
    return findValue(n, [{
      95: '#1c39a1'
    }, {
      90: '#2d4dc5'
    }, {
      80: '#2e51d1'
    }, {
      70: '#3157e1'
    }, {
      60: '#3a63f9'
    }, {
      50: '#3d6ef5'
    }, {
      40: '#537ef5'
    }, {
      30: '#6790ff'
    }, {
      20: '#a5c6ff'
    }, {
      10: '#e8f1ff'
    }, {
      1: '#f0f6ff'
    }]);
  },
  green: function green(n) {
    return findValue(n, [{
      95: '#0c6a51'
    }, {
      90: '#067554'
    }, {
      80: '#01875a'
    }, {
      70: '#049464'
    }, {
      60: '#07a87d'
    }, {
      50: '#1ac99a'
    }, {
      40: '#47d6b0'
    }, {
      30: '#75e1c4'
    }, {
      20: '#c4f5e8'
    }, {
      10: '#e9fff9'
    }, {
      1: '#f0fffa'
    }]);
  },
  red: function red(n) {
    return findValue(n, [{
      95: '#b52828'
    }, {
      90: '#c22f2f'
    }, {
      80: '#d24343'
    }, {
      70: '#de423e'
    }, {
      60: '#ee5c5c'
    }, {
      50: '#f26d6d'
    }, {
      40: '#f57a7a'
    }, {
      30: '#f78888'
    }, {
      20: '#fabbc0'
    }, {
      10: '#ffeff1'
    }, {
      1: '#fff5f6'
    }]);
  },
  yellow: function yellow(n) {
    return findValue(n, [{
      95: '#eb9800'
    }, {
      90: '#f2a60c'
    }, {
      80: '#ffb81c'
    }, {
      70: '#fac234'
    }, {
      60: '#f8cd4f'
    }, {
      50: '#fad464'
    }, {
      40: '#fcdc79'
    }, {
      30: '#ffe38e'
    }, {
      20: '#ffeeba'
    }, {
      10: '#fff9e8'
    }, {
      1: '#fffbf0'
    }]);
  },
  blue: function blue(n) {
    return findValue(n, [{
      95: '#0e497b'
    }, {
      90: '#155c99'
    }, {
      80: '#1f72b8'
    }, {
      70: '#2e82c7'
    }, {
      60: '#459ae1'
    }, {
      50: '#54a7eb'
    }, {
      40: '#69b6f5'
    }, {
      30: '#7bc3ff'
    }, {
      20: '#c0e2ff'
    }, {
      10: '#ecf7ff'
    }, {
      1: '#f2faff'
    }]);
  },
  orange: function orange(n) {
    return findValue(n, [{
      95: '#b33c00'
    }, {
      90: '#c24700'
    }, {
      80: '#db7c38'
    }, {
      70: '#e58840'
    }, {
      60: '#f39747'
    }, {
      50: '#f5a158'
    }, {
      40: '#f7ab68'
    }, {
      30: '#fbb77c'
    }, {
      20: '#fcd4ae'
    }, {
      10: '#fff1e3'
    }, {
      1: '#fff5ed'
    }]);
  },
  purple: function purple(n) {
    return findValue(n, [{
      95: '#4616b5'
    }, {
      90: '#4e1cc6'
    }, {
      80: '#533cd6'
    }, {
      70: '#6855e0'
    }, {
      60: '#6d62e9'
    }, {
      50: '#8373ee'
    }, {
      40: '#8c81f0'
    }, {
      30: '#9a92ef'
    }, {
      20: '#bfbaf5'
    }, {
      10: '#eae8fe'
    }, {
      1: '#f3f2ff'
    }]);
  },
  neutral: function neutral(n) {
    return findValue(n, [{
      100: '#000000'
    }, {
      95: '#121d2e'
    }, {
      90: '#1f2d46'
    }, {
      80: '#2e3a4f'
    }, {
      70: '#3f4d64'
    }, {
      60: '#5c697f'
    }, {
      50: '#78869b'
    }, {
      40: '#9ba7bc'
    }, {
      30: '#afb9cb'
    }, {
      20: '#c5cedd'
    }, {
      10: '#e5e9f1'
    }, {
      1: '#f7f9fc'
    }, {
      0: '#ffffff'
    }]);
  },
  white: '#ffffff'
};
var _default = {
  luna: {
    colors: colors,
    zIndex: _zIndex.default,
    spacing: function spacing(n) {
      return findValue(n, [{
        1: '4px'
      }, {
        2: '8px'
      }, {
        3: '12px'
      }, {
        4: '16px'
      }, {
        5: '20px'
      }, {
        6: '24px'
      }, {
        7: '32px'
      }, {
        8: '36px'
      }, {
        9: '40px'
      }, {
        10: '48px'
      }, {
        11: '56px'
      }, {
        12: '64px'
      }, {
        13: '96px'
      }]);
    },
    fonts: {}
  }
};
exports.default = _default;
//# sourceMappingURL=luna.js.map